
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"100%","height":"100%","viewBox":"0 0 20 20","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M14.1667 9.16617H7.84166L10.5917 6.4245C10.7486 6.26758 10.8367 6.05475 10.8367 5.83284C10.8367 5.61092 10.7486 5.39809 10.5917 5.24117C10.4347 5.08425 10.2219 4.99609 10 4.99609C9.77808 4.99609 9.56525 5.08425 9.40833 5.24117L5.24166 9.40784C5.16579 9.48709 5.10632 9.58054 5.06666 9.68284C4.98331 9.88572 4.98331 10.1133 5.06666 10.3162C5.10632 10.4185 5.16579 10.5119 5.24166 10.5912L9.40833 14.7578C9.4858 14.8359 9.57797 14.8979 9.67951 14.9402C9.78106 14.9826 9.88999 15.0043 10 15.0043C10.11 15.0043 10.2189 14.9826 10.3205 14.9402C10.422 14.8979 10.5142 14.8359 10.5917 14.7578C10.6698 14.6804 10.7318 14.5882 10.7741 14.4867C10.8164 14.3851 10.8382 14.2762 10.8382 14.1662C10.8382 14.0562 10.8164 13.9472 10.7741 13.8457C10.7318 13.7441 10.6698 13.652 10.5917 13.5745L7.84166 10.8328H14.1667C14.3877 10.8328 14.5996 10.745 14.7559 10.5888C14.9122 10.4325 15 10.2205 15 9.9995C15 9.77849 14.9122 9.56653 14.7559 9.41025C14.5996 9.25397 14.3877 9.16617 14.1667 9.16617Z","fill":"currentColor"}})])
          )
        }
      }
    